import React, { useState, useEffect, useRef } from "react";
import { Mail, Phone, MapPin, Clock, Send, User, MessageCircle, Building, Zap, CheckCircle } from "lucide-react";
import emailjs from "emailjs-com";
const useInView = (t = 0.1) => {
  const ref = useRef(null); const [v, setV] = useState(false);
  useEffect(() => {
  const el = ref.current; if (!el) return;
  const o = new IntersectionObserver(([e]) => { 
    if (e.isIntersecting) { 
      setV(true); 
      o.disconnect(); 
    } 
  }, { threshold: t });
  o.observe(el); 
  return () => o.disconnect();
}, [t]);
  return [ref, v];
};

const contactItems = [
  { n: "01", icon: Mail, title: "Email Us", line1: "wayforwardit@gmail.com", line2: "We reply within 24 hours" },
  { n: "02", icon: Phone, title: "Call Us", line1: "+1 (555) 123-4567", line2: "Mon–Fri 9AM–6PM EST" },
  { n: "03", icon: MapPin, title: "Visit Us", line1: "5900 Balcones Drive #27580", line2: "Austin, TX 78731" },
  { n: "04", icon: Clock, title: "Business Hours", line1: "Mon–Fri: 9AM–6PM", line2: "Sat–Sun: Emergency only" },
];
const Fld = ({ name, label, icon: Ic, type = "text", req, ph, children, value, onChange, focused, setFocused }) => {
  return (
    <div className={`cf-field ${focused === name ? "foc" : ""}`}>
      <label htmlFor={name}>
        {label}{req && <span className="cf-req">*</span>}
      </label>

      <div className="cf-wrap">
        <Ic size={15} className="cf-fic" />

        {children || (
          type === "textarea" ? (
            <textarea
              id={name}
              name={name}
              value={value}
              onChange={onChange}
              required={req}
              placeholder={ph}
              rows={5}
              onFocus={() => setFocused(name)}
              onBlur={() => setFocused("")}
            />
          ) : (
            <input
              id={name}
              name={name}
              type={type}
              value={value}
              onChange={onChange}
              required={req}
              placeholder={ph}
              onFocus={() => setFocused(name)}
              onBlur={() => setFocused("")}
            />
          )
        )}
      </div>
    </div>
  );
};
function ContactForm() {
  const [form, setForm] = useState({ name: "", email: "", company: "", phone: "", service: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [focused, setFocused] = useState("");

  const onChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const onSubmit = (e) => {
  e.preventDefault();
  setSubmitting(true);

  emailjs.send(
    "service_xidrybe",
    "template_7blj724",
    {
      name: form.name,
      email: form.email,
      company: form.company,
      phone: form.phone,
      service: form.service,
      message: form.message,
    },
    "yFgBsrs_kEAXDB6fg"
  )
  .then(() => {
    setSubmitting(false);
    setDone(true);
  })
  .catch((error) => {
    console.error(error);
    setSubmitting(false);
  });
};
  if (done) return (
    <div className="cf-success">
      <CheckCircle size={44} />
      <h3>Message Sent!</h3>
      <p>Thank you for reaching out. We'll respond within 24 hours.</p>
    </div>
  );

  

  return (
    <form className="cf-form" onSubmit={onSubmit}>
      <Fld
  name="name"
  label="Full Name"
  icon={User}
  req
  ph="Your full name"
  value={form.name}
  onChange={onChange}
  focused={focused}
  setFocused={setFocused}
/>
      <div className="cf-row">
        <Fld
  name="email"
  label="Email Address"
  icon={Mail}
  type="email"
  req
  ph="you@company.com"
  value={form.email}
  onChange={onChange}
  focused={focused}
  setFocused={setFocused}
/>
        <Fld
  name="phone"
  label="Phone Number"
  icon={Phone}
  ph="+1 (555) 000-0000"
  value={form.phone}
  onChange={onChange}
  focused={focused}
  setFocused={setFocused}
/>
      </div>
      <Fld
  name="company"
  label="Company Name"
  icon={Building}
  ph="Your company"
  value={form.company}
  onChange={onChange}
  focused={focused}
  setFocused={setFocused}
/>
      <div className={`cf-field ${focused === "service" ? "foc" : ""}`}>
        <label htmlFor="service">Service Interest</label>
        <div className="cf-wrap">
          <Zap size={15} className="cf-fic" />
          <select id="service" name="service" value={form.service} onChange={onChange} onFocus={() => setFocused("service")} onBlur={() => setFocused("")}>
            <option value="">Select a service</option>
            {["Custom Software Development","Cloud Solutions & Migration","Cybersecurity Services","Mobile App Development","Data Analytics & BI","IT Infrastructure Management","Network Solutions","Technical Support","General Consultation"].map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
      </div>
      <Fld
  name="message"
  label="Your Message"
  icon={MessageCircle}
  type="textarea"
  req
  ph="Tell us about your project and requirements..."
  value={form.message}
  onChange={onChange}
  focused={focused}
  setFocused={setFocused}
/>
      <button type="submit" className="cf-submit" disabled={submitting}>
        {submitting ? <><div className="cf-spin" />Sending…</> : <><Send size={15} />Send Message</>}
      </button>
    </form>
  );
}

export default function Contact() {
  const [infoRef, infoIn] = useInView();
  const [formRef, formIn] = useInView();

  return (
    <div className="cp">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Instrument+Serif:ital@0;1&display=swap');

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:root {
  --blue: #2563eb;
  --blue2: #3b82f6;
  --darkblue: #1e40af;
  --black: #080808;
  --lgray: #f7f7f7;
  --white: #ffffff;
  --txd: #111827;      /* dark text */
  --txm: #4b5563;      /* medium text */
  --txl: #9ca3af;      /* light text */
  --bd: rgba(15,23,41,0.15);
  --bd-strong: rgba(15,23,41,0.25);
  --input-bg: #ffffff;
  --input-border: #d1d5db;
  --input-focus: #2563eb;
  --f: 'Inter', sans-serif;
  --serif: 'Instrument Serif', serif;
}

.cp {
  font-family: var(--f);
  background: var(--black);
  overflow-x: hidden;
}

/* HERO */
.cp-hero {
  position: relative;
  background: var(--black);
  padding: 10rem 1.5rem 5rem;
  text-align: center;
  overflow: hidden;
  border-bottom: 1px solid rgba(255,255,255,.1);
}
.cp-dots {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(circle, rgba(255,255,255,.06) 1px, transparent 1px);
  background-size: 32px 32px;
  mask-image: radial-gradient(ellipse 70% 60% at 50% 50%, #000 20%, transparent 100%);
}
.cp-glow {
  position: absolute;
  top: -80px;
  left: 50%;
  transform: translateX(-50%);
  width: 700px;
  height: 350px;
  border-radius: 50%;
  background: radial-gradient(ellipse, rgba(37,99,235,.18), transparent 65%);
  filter: blur(50px);
  z-index: 0;
  pointer-events: none;
}
.cp-line {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(37,99,235,.5), transparent);
  animation: lineIn .8s ease .1s both;
}
@keyframes lineIn { from{opacity:0; transform:scaleX(0);} to{opacity:1; transform:scaleX(1);} }

.cp-hero-con {
  position: relative;
  z-index: 1;
  max-width: 700px;
  margin: 0 auto;
}
.cp-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255,255,255,.05);
  border: 1px solid rgba(255,255,255,.1);
  border-radius: 100px;
  padding: .4rem 1rem;
  font-size: .67rem;
  font-weight: 600;
  letter-spacing: .12em;
  text-transform: uppercase;
  color: rgba(255,255,255,.4);
  margin-bottom: 1.75rem;
  opacity: 0;
  animation: fadeUp .7s ease .2s both;
}
.cp-badge-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--blue2);
  animation: blink 2s infinite;
}
@keyframes blink { 0%,100%{opacity:1;}50%{opacity:.2;} }

.cp-h1 {
  font-size: clamp(2.4rem,5vw,4.5rem);
  font-weight: 900;
  line-height: 1.02;
  letter-spacing: -.045em;
  color: #fff;
  margin-bottom: 1.1rem;
}
.cp-h1 .w {
  display: inline-block;
  opacity: 0;
  transform: translateY(100%);
  animation: wordUp .8s cubic-bezier(.16,1,.3,1) both;
  margin-right: .25em;
}
.cp-h1 .w.bl {
  background: linear-gradient(135deg,#93c5fd,#3b82f6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
@keyframes wordUp { to{opacity:1; transform:translateY(0);} }

.cp-sub {
  font-size: .93rem;
  line-height: 1.72;
  color: #d1d5db; /* lighter gray for hero subtext */
  max-width: 460px;
  margin: 0 auto;
  opacity: 0;
  animation: fadeUp .7s ease .7s both;
}

/* BODY SECTION */
.cp-body {
  background: var(--lgray);
  padding: 6rem 1.5rem 8rem;
  border-top: 1px solid rgba(0,0,0,.06);
}
.cp-wrap {
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 440px;
  gap: 5rem;
  align-items: start;
}

/* FORM */
.cf-form {
  background: #f9fafb;
  border: 1px solid var(--bd-strong);
  border-radius: 18px;
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.cf-form.vis { opacity:1; transform:translateY(0); }
.cf-wrap-box {
  opacity: 0;
  transform: translateY(24px);
  transition: opacity .7s ease, transform .7s cubic-bezier(.16,1,.3,1);
}
.cf-wrap-box.vis {
  opacity:1;
  transform:translateY(0);
}
.cf-row { display:grid; grid-template-columns:1fr 1fr; gap:1rem; }
.cf-field { display:flex; flex-direction:column; gap:.38rem; }
.cf-field label {
  font-size:.68rem;
  font-weight:600;
  letter-spacing:.08em;
  text-transform: uppercase;
  color: #111827; /* 🔥 stronger visible */
}
.cf-field.foc label { color: var(--blue); }
.cf-req { color: var(--blue); margin-left:3px; }

.cf-wrap {
  position: relative;
  display: flex;
  align-items: flex-start;
}
.cf-fic {
  position: absolute;
  left:.9rem;
  top:.95rem;
  color: #9ca3af;
  pointer-events: none;
  z-index:1;
  transition: color .2s;
}
.cf-field.foc .cf-fic { color: var(--blue); }

.cf-wrap input, .cf-wrap select, .cf-wrap textarea {
  width: 100%;
  padding: .88rem 1rem .88rem 2.65rem;
  background: var(--input-bg);
  border: 1.5px solid var(--bd-strong);
  border-radius: 10px;
  color: var(--txd);
  font-family: var(--f);
  font-size: .875rem;
  outline: none;
  transition: all .2s ease;
  color: #111827; /* 🔥 force visible */
}
.cf-wrap input::placeholder, .cf-wrap textarea::placeholder { color:#9ca3af; }
.cf-wrap input:focus, .cf-wrap select:focus, .cf-wrap textarea:focus {
  border-color: rgba(37,99,235,.6);
  background: #fff;
  box-shadow: 0 0 0 3px rgba(37,99,235,.08);
}
.cf-wrap select { cursor:pointer; color: var(--txd); }
.cf-wrap select option { background: #fff; }
.cf-wrap textarea { resize: vertical; min-height: 130px; }

.cf-submit {
  display:flex;
  align-items:center;
  justify-content:center;
  gap:.55rem;
  background: var(--blue);
  border:none;
  border-radius:10px;
  color:#fff;
  cursor:pointer;
  font-family:var(--f);
  font-size:.875rem;
  font-weight:700;
  letter-spacing:.04em;
  text-transform: uppercase;
  padding:.95rem;
  transition: all .25s ease;
  box-shadow:0 4px 16px rgba(37,99,235,.25);
}
.cf-submit:hover:not(:disabled){
  background:#1d4ed8;
  transform: translateY(-2px);
  box-shadow:0 10px 28px rgba(37,99,235,.4);
}
.cf-submit:disabled { opacity:.6; cursor:not-allowed; }
.cf-spin {
  width:16px; height:16px;
  border:2px solid rgba(255,255,255,.3);
  border-top-color:#fff;
  border-radius:50%;
  animation: spin .8s linear infinite;
}
@keyframes spin { to{transform:rotate(360deg);} }

.cf-success {
  background:#f3f4f6;
  border:1.5px solid #10b981;
  border-radius:18px;
  padding:3rem;
  text-align:center;
}
.cf-success svg { color:#10b981; margin-bottom:1rem; display:block; margin-left:auto; margin-right:auto; }
.cf-success h3 { font-size:1.4rem; font-weight:700; color:#10b981; margin-bottom:.5rem; letter-spacing:-.02em; }
.cf-success p { font-size:.88rem; color:#374151; line-height:1.65; }

/* SIDEBAR */
.cp-sidebar {
  display:flex; flex-direction:column; gap:0;
  position:sticky; top:92px;
  opacity:0; transform:translateY(24px);
  transition: opacity .7s ease .1s, transform .7s cubic-bezier(.16,1,.3,1) .1s;
}
.cp-sidebar.vis { opacity:1; transform:translateY(0); }
.cp-info-title { font-size:.75rem; font-weight:700; letter-spacing:.15em; text-transform:uppercase; color: var(--darkblue); margin-bottom:1.5rem; }

/* Numbered contact items */
.cp-ci {
  display:grid; grid-template-columns:52px 1fr; gap:1.5rem; align-items:start;
  padding:2rem 0; border-bottom:1px solid var(--bd);
  transition:opacity .2s ease;
}
.cp-ci:first-of-type { padding-top:0; }
.cp-ci:last-of-type { border-bottom:none; }
.cp-ci:hover { opacity:.85; }
.cp-ci-n {
  font-size:2.8rem; font-weight:900; color:#9ca3af; letter-spacing:-.06em; line-height:.9; user-select:none;
}
.cp-ci-icon {
  width:40px; height:40px; border-radius:10px; background: rgba(37,99,235,.08); color:var(--blue);
  display:flex; align-items:center; justify-content:center; margin-bottom:.75rem; flex-shrink:0;
}
.cp-ci-title { font-size:.75rem; font-weight:700; letter-spacing:.08em; text-transform:uppercase; color: var(--darkblue); margin-bottom:.3rem; }
.cp-ci-line1 { font-size:.92rem; font-weight:600; color: var(--txd); margin-bottom:.15rem; letter-spacing:-.01em; }
.cp-ci-line2 { font-size:.78rem; color: var(--txm); }

/* Trust section */
.cp-trust { background: var(--black); padding:1.5rem; border-radius:14px; margin-top:2rem; }
.cp-trust-title { font-size:.75rem; font-weight:700; letter-spacing:.15em; text-transform:uppercase; color: var(--blue2); margin-bottom:1rem; }
.cp-trust-items { display:flex; flex-direction:column; gap:.75rem; }
.cp-trust-item { display:flex; align-items:center; gap:.75rem; font-size:.875rem; color:#d1d5db; font-weight:500; }
.cp-trust-item svg { color: var(--blue2); flex-shrink:0; opacity:.85; }

/* WHY SECTION */
.cp-why { background: var(--black); padding:8rem 1.5rem; border-top:1px solid rgba(255,255,255,.1); }
.cp-why-wrap { max-width:1000px; margin:0 auto; }
.sec-lbl { display:block; font-size:.75rem; font-weight:700; letter-spacing:.15em; text-transform:uppercase; color: var(--blue2); margin-bottom:.85rem; }
.sec-h { font-size:clamp(1.8rem,3vw,2.8rem); font-weight:900; letter-spacing:-.04em; line-height:1.08; color:#fff; margin-bottom:4rem; }
.sec-h em { font-style:italic; font-family: var(--serif); color:#93c5fd; }

.why-row {
  display:grid; grid-template-columns:100px 1fr; gap:3rem; align-items:start; padding:3.5rem 0; border-bottom:1px solid rgba(255,255,255,.1);
  opacity:0; transform:translateY(20px);
  transition: opacity .6s ease, transform .6s cubic-bezier(.16,1,.3,1);
}
.why-row:last-child { border-bottom:none; }
.why-row.vis { opacity:1; transform:translateY(0); }
.why-n { font-size:5rem; font-weight:900; color: rgba(255,255,255,.07); letter-spacing:-.06em; line-height:.9; user-select:none; }
.why-t { font-size:1.2rem; font-weight:700; color:#fff; letter-spacing:-.025em; margin-bottom:.6rem; }
.why-d { font-size:.95rem; line-height:1.75; color:#d1d5db; max-width:520px; }

@keyframes fadeUp { from{opacity:0; transform:translateY(18px);} to{opacity:1; transform:translateY(0);} }

@media(max-width:900px){
  .cp-wrap { grid-template-columns:1fr; gap:3rem; }
  .cp-sidebar { position:relative; top:0; }
  .why-row { grid-template-columns:60px 1fr; gap:1.5rem; }
  .why-n { font-size:3rem; }
}
@media(max-width:600px){
  .cf-row { grid-template-columns:1fr; }
  .cf-form { padding:1.5rem; }
}
      `}</style>

      {/* HERO */}
      <div className="cp-hero">
        <div className="cp-dots" /><div className="cp-glow" /><div className="cp-line" />
        <div className="cp-hero-con">
          <div className="cp-badge"><div className="cp-badge-dot" />Get In Touch</div>
          <h1 className="cp-h1">
            <span className="w" style={{ animationDelay: ".3s" }}>Let's</span>
            <span className="w bl" style={{ animationDelay: ".44s" }}>Talk</span>
          </h1>
          <p className="cp-sub">Ready to transform your business with innovative IT solutions? Our experts are here for you.</p>
        </div>
      </div>

      {/* LIGHT GRAY BODY */}
      <div className="cp-body">
        <div className="cp-wrap">
          {/* Form */}
          <div ref={formRef} className={`cf-wrap-box ${formIn ? "vis" : ""}`}>
  <ContactForm />
</div>

          {/* Sidebar with numbered contact items */}
          <aside ref={infoRef} className={`cp-sidebar ${infoIn ? "vis" : ""}`}>
            <div className="cp-info-title">Contact Information</div>

            {contactItems.map((c, i) => (
              <div key={i} className="cp-ci" style={{ transitionDelay: `${i * .08}s` }}>
                <div className="cp-ci-n">{c.n}</div>
                <div>
                  <div className="cp-ci-icon"><c.icon size={18} /></div>
                  <div className="cp-ci-title">{c.title}</div>
                  <div className="cp-ci-line1">{c.line1}</div>
                  <div className="cp-ci-line2">{c.line2}</div>
                </div>
              </div>
            ))}

            
          </aside>
        </div>
      </div>

      {/* DARK WHY SECTION */}
      <section className="cp-why">
        <div className="cp-why-wrap">
          <span className="sec-lbl">What to Expect</span>
          <h2 className="sec-h">We keep things<br /><em>simple</em></h2>
          {[
            { n: "01", t: "You reach out", d: "Fill out the form or send us a message. We read every inquiry personally — no bots, no automated brushoffs." },
            { n: "02", t: "We respond fast", d: "Expect a reply within 24 hours. We'll ask a few questions to understand your needs before jumping to solutions." },
            { n: "03", t: "We get to work", d: "Once aligned, we build a clear plan and start delivering. Transparent communication throughout, no surprises." },
          ].map((w, i) => (
            <div key={i} className={`why-row ${infoIn ? "vis" : ""}`} style={{ transitionDelay: `${i * .12}s` }}>
              <div className="why-n">{w.n}</div>
              <div><div className="why-t">{w.t}</div><div className="why-d">{w.d}</div></div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
